import { FC } from 'react'
import { NavLink } from 'react-router-dom'

import styles from './Sponsors.module.scss'

type SponsorInfo = {
  id: string
  url: string
  name?: string
  image: string
  vacantions?: any[]
  style?: any
}

export type SponsorCardInfo = {
  id: string
  categoryName: string
  sponsors: SponsorInfo[]
}

type TSponsorCard = {
  data: SponsorCardInfo
  modalToggler?: any
}
const SponsorCard: FC<TSponsorCard> = ({ data, modalToggler }) => {
  const { categoryName, sponsors } = data

  return (
    <div className={styles.wrapper__list}>
      <div className={styles.wrapper__list__container}>
        <p className={styles.wrapper__list__container_name}>{categoryName}</p>
        <div className={styles.wrapper__list__container__items}>
          {sponsors.map(sponsor => (
            <div key={sponsor.id} className={styles.wrapper__items}>
              <NavLink
                key={sponsor.url}
                target='_blank'
                to={sponsor.url}
                className={styles.wrapper__list__container__items__item}
              >
                <img src={sponsor.image} alt='sponsor' style={{ ...sponsor.style }} />
              </NavLink>
              {sponsor.vacantions && (
                <button
                  className={styles.wrapper__list__container__items__item_vacantion_button}
                  onClick={() => modalToggler && modalToggler(sponsor.id)}
                >
                  Open Positions
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default SponsorCard
